import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UdM} from "../../../_models/UdM";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {SaveMessage} from "../../../_helpers/save-message";
import {ArticoliService} from "../../../_services/articoli.service";
import {SearchResult} from "../../../_models/SearchResult";

@Component({
  selector: 'app-udm-input',
  templateUrl: './udm-input.component.html',
  styleUrls: ['./udm-input.component.scss'],
  standalone: false
})
export class UdmInputComponent {
  @Input() codUdM = '';
  @Output() codUdMChange = new EventEmitter<string>();
  @Input() tipoUdM = -1;
  @Input() label = 'Seleziona unità di misura';
  udms: UdM[] = [];
  showUdM = false;
  loading = false;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage,
    private articoliService: ArticoliService) { }


  resetUdM = () => this.codUdMChange.emit('');

  getUdM() {
    this.showUdM = !this.showUdM;
    if (!this.showUdM) {
      this.udms = [];
      return false;
    }
    this.loading = true;
    this.articoliService.getUdM(this.organizzazioniService.organizzazioneId, this.tipoUdM)
      .then((_udm: SearchResult<UdM>) => this.udms = _udm.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dell'unità di misura."))
      .finally(() => this.loading = false);
  }

  selectUdM = (udm: UdM) => {
    if (!udm || !udm.codUnitaMisura) {
      return false;
    }
    this.showUdM = false;
    this.udms = [];
    this.codUdMChange.emit(udm.codUnitaMisura);
  };
}
